import { ObjectHelpers } from "../../helpers/object-helpers";

export enum TradeOrderType {
    Stop = 'Stop',
    Limit = 'Limit',
    Market = 'Market',
}

export enum TradeInForceType {
    Day = 'Day',
    Week = 'Week'
}

export enum QuoteType {
    Shares = 'Shares',
    Dollars = 'Dollars'
}

export class TradeModel {
    public isBuy = false;
    public isFromOEP = false;
    public defaultPrice = 0;
    public price = 0;
    public quoteQuantity = 1000;
    public tif = TradeInForceType.Day;
    public orderType = TradeOrderType.Limit;
    public quoteType = QuoteType.Shares;
    public account = '';
    public accountLabel = '';
    public ocaGroup = '';
    public source: number | null = null;

    public defaultTIF = TradeInForceType.Day;
    public defaultOrderType = TradeOrderType.Market;
    ;
    public defaultQuoteType = QuoteType.Shares;

    constructor(data?: any) {
        if (data) ObjectHelpers.setPropertiesAndFunctions(data, this, true);
    }
}